import ApiService from "./api.service";
import { CONSENT_TYPE } from "@/configs/constants";

export const MARKETING_CONSENT_SUBMIT_TYPE = CONSENT_TYPE.ONBOARDING;

const MarketingConsentService = {
  async getUserConsents(type = CONSENT_TYPE.ONBOARDING) {
    return ApiService.get(`marketing-consents/${type}`);
  },

  async getAllUserConsents() {
    return ApiService.get("marketing-consents/all");
  },

  async submitConsents({ type = MARKETING_CONSENT_SUBMIT_TYPE, answers }) {
    return ApiService.post("marketing-consents/submit", { type, answers });
  },
};

export { MarketingConsentService };
